module.exports = __webpack_public_path__ + "static/img/ex07.bc398a50.png";